export default {
      id: "user-usage",
      viewBox: "0 0 23.26 30.58",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#user",
      toString: function () {
        return this.url;
      }
    }